// extracted by mini-css-extract-plugin
export default {"header":"SingleSignOnLogin_header__30zya","divider":"SingleSignOnLogin_divider__NM3K5"};